import { useState, useEffect } from 'react';

export const useResize = () => {
  const [ resize, setResize ] = useState(true);

  useEffect(() => {
    window.innerHeight >= 360 ? setResize(false) : setResize(true);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const handleResize = () => {
    window.innerHeight >= 360 ? setResize(false) : setResize(true);
  };

  return resize;
};
